module.exports = __webpack_public_path__ + "static/media/flag-red.4a9c6e66.svg";